import { api } from '../lib/api';

export interface PurchaseDocumentV2ListItem {
  id: number;
  documentNumber: string;
  purchaseType: string;
  supplierId: number | null;
  supplierName: string | null;
  documentDate: string;
  notes: string | null;
  rowCount: number;
  totalQty: string | number;
}

export interface PurchaseDocumentV2Row {
  id?: number;
  sortOrder?: number;
  containerId?: number | null;
  ledgerTxId?: number | null;
  isBatchLocked?: boolean;
  containerCode?: string | null;
  productId: number;
  qty: number;
  uomItemId: number | null;
  siteId: number | null;
  waterPercent?: number | null;
  nectarItemId?: number | null;
  notes?: string | null;
  productSku?: string | null;
  productName?: string | null;
  productKind?: string | null;
  categoryLabel?: string | null;
  nectarLabel?: string | null;
  uomLabel?: string | null;
  siteName?: string | null;
}

export interface PurchaseDocumentV2Detail {
  id: number;
  documentNumber: string;
  purchaseType: string;
  supplierId: number | null;
  supplierName: string | null;
  documentDate: string;
  notes: string | null;
  rows: PurchaseDocumentV2Row[];
}

export interface PurchaseDocumentsV2Meta {
  suppliers: Array<{ id: number; name: string }>;
  products: Array<{
    id: number;
    sku: string | null;
    name: string;
    kind: string | null;
    defaultUomItemId: number | null;
    categoryItemId: number | null;
    categoryLabel: string | null;
  }>;
  uoms: Array<{ id: number; label: string }>;
  sites: Array<{ id: number; name: string }>;
  purchaseTypes: Array<{ value: string; label: string }>;
  nextDocumentNumber: string;
}

export interface PurchaseDocumentV2FormData {
  purchaseType: string;
  supplierId: number | null;
  documentDate: string;
  notes?: string;
  rows: Array<{
    id?: number | null;
    containerCode?: string | null;
    productId: number;
    qty: number;
    uomItemId?: number | null;
    siteId?: number | null;
    waterPercent?: number | null;
    nectarItemId?: number | null;
    notes?: string | null;
  }>;
}

export const purchaseDocumentsV2Api = {
  list: () => api.get<{ documents: PurchaseDocumentV2ListItem[] }>('/purchase-docs-v2'),
  meta: () => api.get<PurchaseDocumentsV2Meta>('/purchase-docs-v2/meta'),
  get: (id: number) => api.get<PurchaseDocumentV2Detail>(`/purchase-docs-v2/${id}`),
  create: (data: PurchaseDocumentV2FormData) =>
    api.post<{ id: number; documentNumber: string }>('/purchase-docs-v2', data),
  update: (id: number, data: PurchaseDocumentV2FormData) =>
    api.patch<{ ok: boolean }>(`/purchase-docs-v2/${id}`, data),
};
